import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CancelButton } from '../components/ui';
import styled from 'styled-components';
import useTheme from '@material-ui/core/styles/useTheme';
import { ThemeProvider } from '@material-ui/core';

type Props = {
  onSave?: (data: any) => void;
  onCancel?: () => void;
};

const SaveFooterLayout: React.FC<Props> = ({ onSave, onCancel, children }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  return (
    <ThemeProvider theme={theme}>
      <div className="flex-1-1-0">{children}</div>
      <StyledButtons className="mobileCtrlProfileFooterButtonsWrapper">
        <CancelButton onClick={onCancel}>{t('Cancel')}</CancelButton>
        {onSave && (
          <Button onClick={onSave} className="w-48 place-self-center">
            <span className="px-14">{t('Save')}</span>
          </Button>
        )}
      </StyledButtons>
    </ThemeProvider>
  );
};

const StyledButtons = styled.div`
  text-align: center;
  justify-content: center;

  border-top: 2px dotted #e3e5e6;
  padding: 1rem 0;
  background-color: rgb(237, 243, 255);
`;

export default SaveFooterLayout;
